const handleCloseFormParamUser = {
  confirm: 'Deseja realmente sair sem salvar as alterações?',
  title: 'ALTERAÇÕES NÃO SALVAS'
};

export default handleCloseFormParamUser;
